import { BufferUsage } from '@antv/g-plugin-webgl-renderer'; // const containerModule = Module((register) => {
//   register(HTMLRenderingPlugin);
// });

export * from './interface';
export * from './Kernel';
export { BufferUsage };

var Plugin =
/** @class */
function () {
  function Plugin() {}

  Plugin.prototype.init = function (container) {// container.load(containerModule, true);
  };

  Plugin.prototype.destroy = function (container) {// container.unload(containerModule);
  };

  return Plugin;
}();

export { Plugin };